var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.9986 0C31.7876 0 0 31.7876 0 70.9986C0 110.123 31.9018 142.014 71.0231 142C110.226 141.986 142 110.204 142 70.9986C142 31.793 110.212 0 70.9986 0ZM82.422 132.999C72.7362 134.859 62.7458 134.218 53.2694 131.575C51.9533 131.221 51.9179 131.091 52.9594 130.196C63.7574 120.725 79.4853 115.662 93.462 120.382C96.7224 121.53 98.6693 120.651 102.653 119.422C107.333 117.978 107.635 116.2 109.908 109.611C110.245 108.635 109.329 107.599 108.744 106.707C106.987 104.029 105.266 101.334 103.947 98.4029C102.384 94.9331 101.519 91.3383 101.601 87.507C101.663 84.543 100.344 82.0223 98.702 79.711C98.4627 79.3738 98.1663 79.0829 97.8182 78.8599C95.8033 77.5737 92.717 77.9326 90.4111 77.9571C98.6639 74.3025 104.263 79.333 112.013 79.4635C115.648 79.1345 119.463 77.5356 121.008 73.9925C108.948 77.7831 101.563 64.0592 88.8394 68.4263C83.0502 70.4956 77.8021 66.3406 72.1924 65.5684C62.5963 64.187 53.1361 67.5371 44.3884 71.1482C42.1967 72.1516 39.9942 72.845 37.6448 71.8443C36.1438 71.5234 36.19 70.3814 37.5822 69.9517C40.209 68.6927 42.175 66.6588 43.9941 64.4481C44.4075 63.9477 44.3639 63.7547 43.695 63.5725C39.9643 62.6371 36.9976 65.7642 34.5286 68.0619C30.7108 71.4636 25.1717 69.0517 21.6096 66.4847C21.2207 66.1639 20.7557 66.2427 20.3587 66.085C13.7728 64.6982 27.2193 55.2082 26.3736 49.854C26.5667 45.6066 24.5246 42.6291 28.1466 39.2219C29.8379 37.9167 33.43 32.1248 35.241 32.5789C36.6115 32.7583 38.0064 32.9541 39.5455 32.6115C37.294 31.4558 33.7753 30.5014 34.4035 27.3444C34.9337 24.1629 38.7053 23.9943 41.313 24.2119C42.8738 24.3424 43.1403 24.065 43.9724 23.4804C47.5019 21.0114 51.5671 19.7415 55.6296 18.545C63.8743 16.1657 72.516 13.713 79.5234 8.5492C149.304 19.1106 153.396 118.166 82.4193 132.999H82.422Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8053 42.4155L33.8108 49.7922L30.4287 47.7596L37.8053 42.4155Z",
    fill: "#D34253"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_31_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.5444 96.8184L99.5848 94.5111L91.2861 87.5977L95.5444 96.8184Z",
    fill: "#28FDD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31_24",
    x: 26.4287,
    y: 38.4155,
    width: 15.3766,
    height: 15.3766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_24"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31_24",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_31_24",
    x: 88.2861,
    y: 84.5977,
    width: 14.2987,
    height: 15.2208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.992157 0 0 0 0 0.843137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_24"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31_24",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.8d9d61923dc1613b746bf39ad20037c0.svg";
export { ForwardRef as ReactComponent };